import { chatMessageFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {string} chatId
 * @param {number} take
 * @param {string?} beforeId
 * @param {string?} search
 */
export const getChatMessages = (chatId, take, beforeId, search) =>
  makeRequest({
    operationName: 'ChatMessages',
    query: `
      query ChatMessages($chatId: String!, $take: Int!, $beforeId: String, $search: String) {
        chatMessages(chatId: $chatId, take: $take, beforeId: $beforeId, search: $search) {
          ...ChatMessageFragment
        }
      }
      
      ${chatMessageFragment}
    `,
    variables: { chatId, take, beforeId, search },
  });

export const totalUnreadMessagesCount = () =>
  makeRequest({
    operationName: 'TotalUnreadMessagesCount',
    query: `
      query TotalUnreadMessagesCount {
        totalUnreadMessagesCount
      }
    `,
  });

export const chatReadMessages = chatId =>
  makeRequest({
    operationName: 'ChatReadMessages',
    query: `
      query ChatReadMessages($chatId: String!) {
        chatReadMessages(chatId: $chatId) {
          id
          createdAt

          chatId
          accountId
          messageId

          account {
            login
          }
        }
      }
    `,
    variables: { chatId },
  });
